import requests from "./requests";

export default {
  API: {
    Actions: {
      login: (user, password, csrf) => {
        return requests.post(`${process.env.VUE_APP_LOGIN_URL_PREFIX}login`, {
          name: user,
          password: password,
          _token: csrf,
        });
      },
    },
  },
};
